module.exports = __webpack_public_path__ + "static/media/2.8a9c993a.jpeg";